import { VendorPaymentMethod } from '@bookingkit/api-v4';
import {
    PaymentMethodAdditionalFeesType,
} from '@/modules/sell/pages/PaymentMethods/types';
import { AccountingServiceError } from '@/services/AccountingService/Errors/AccountingServiceError';
import { AdditionalFees } from '@bookingkit/api-v4/models/additional-fees';
import { PaymentMethodExperienceFilter } from '@bookingkit/api-v4/models/payment-method-experience-filter';
import {
    VendorPaymentMethodType,
    VendorPaymentMethodExperienceFilterType
} from "@/modules/admin/Pages/VendorPaymentMethods/Types/VendorPaymentMethod";

/**
 * Convert a VendorPaymentMethod from the API to the internal VendorPaymentMethodType
 *
 * This is an anti-corruption layer that maps between the API model and the application model.
 * The main differences are:
 * - payment_method_id in API vs id in app
 * - Preserves vendor_id and available properties
 * - Maps default_additional_fees and vendor_override_additional_fees
 * - Maps experience_filter
 */
export const fromApiVendorPaymentMethodToVendorPaymentMethod = (pm?: VendorPaymentMethod): VendorPaymentMethodType => {
    if (!pm) {
        throw AccountingServiceError.fromMissingProperty('Vendor payment method');
    }

    return {
        id: pm.payment_method_id as VendorPaymentMethodType['id'],
        vendor_id: pm.vendor_id,
        available: pm.available,
        default_additional_fees: mapAdditionalFees(pm.default_additional_fees),
        vendor_override_additional_fees: mapAdditionalFees(pm.vendor_override_additional_fees),
        experience_filter: mapExperienceFilter(pm.experience_filter),
    };
};


const mapAdditionalFees = (fees?: AdditionalFees): PaymentMethodAdditionalFeesType | undefined => {
    if (!fees || fees.variable === undefined) {
        return undefined;
    }

    return {
        variable: fees.variable,
    };
};

const mapExperienceFilter = (
    filter?: PaymentMethodExperienceFilter
): VendorPaymentMethodExperienceFilterType | undefined => {
    if (!filter) {
        return undefined;
    }

    return {
        active_for_all_experiences: filter.active_for_all_experiences || false,
        active_for_experiences: filter.active_for_experiences,
    };
};

export default { fromApiVendorPaymentMethodToVendorPaymentMethod };
